import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("xs-lang") || "it");

  useEffect(() => {
    localStorage.setItem("xs-lang", lang);
    document.documentElement.lang = lang;
    // Le pagine con meta SEO propri (componente Seo) hanno la precedenza sul titolo generale
    if (!window.__xsPageTitle) document.title = translations[lang].meta.title;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
